export const getBSWildRicePackage = newProduct => {
  const newBSWildRicePackage = {
    UPC: newProduct.UPC,
    GrainLength: newProduct.GrainLength,
    Size: newProduct.Size,
  }
  return newBSWildRicePackage
}

export const updateBSWildRicePackage = newProduct => {
  const newBSWildRicePackage = {
    UPC: newProduct.UPC,
    GrainLength: newProduct.GrainLength,
    Size: newProduct.Size,
  }
  return newBSWildRicePackage
}
